import { HttpClient, HttpContext, HttpContextToken, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';

export const LOCAL_REQUEST_FEEDBACK = new HttpContextToken<boolean>(() => false);
export interface ApiResult<T> { Ok: boolean; Message: string | null; Data: T; }
export interface LookupItem {
  Id: number; NameAr: string; NameEn: string; IsActive: boolean; Code?: string;
  CompanyId?: number; CompanyNameAr?: string; CompanyNameEn?: string; CityNameAr?: string; CityNameEn?: string;
}
export interface LookupPage { Result: LookupItem[]; CurrentPage: number; PageSize: number; TotalRows: number; }
export interface ReportSummary { Revenue: number; Tickets: number; ClosedTickets: number; UnpaidTickets: number; }
export interface ReportBucket extends ReportSummary { Start: string; }
export interface ReportPerformer { Id: number; NameAr: string; NameEn: string; Revenue: number; }
export interface ReportPayments { Cash: number; Pos: number; Online: number; Unclassified: number; OnlineCard: number; OnlineMada: number; OnlineOther: number; }
export interface ReportOverview {
  From: string; To: string; PreviousFrom: string; PreviousTo: string; GeneratedAt: string; TimeZone: string;
  Granularity: string; CompanyId: number | null; BranchId: number | null; CompaniesCount: number; BranchesCount: number;
  Current: ReportSummary; Previous: ReportSummary; Series: ReportBucket[]; Payments: ReportPayments;
  PerformerType: 'company' | 'branch'; TopPerformers: ReportPerformer[];
}
export interface ReportQuery { From: string; To: string; CompanyId?: number; BranchId?: number; }

@Injectable({ providedIn: 'root' })
export class ReportingApiService {
  private readonly base = environment.apiUrl.replace(/\/v1\/?$/, '/v2/');
  constructor(private http: HttpClient) {}
  lookup(kind: 'companies' | 'branches', search: string, page: number, companyId?: number) {
    let params = new HttpParams().set('Search', search).set('PageNumber', page).set('PageSize', 50);
    if (companyId) params = params.set('CompanyId', companyId);
    return this.get<LookupPage>(`lookups/${kind}`, params);
  }
  overview(query: ReportQuery) {
    let params = new HttpParams().set('From', query.From).set('To', query.To);
    if (query.CompanyId) params = params.set('CompanyId', query.CompanyId);
    if (query.BranchId) params = params.set('BranchId', query.BranchId);
    return this.get<ReportOverview>('reports/overview', params);
  }
  private get<T>(path: string, params: HttpParams) {
    return this.http.get<ApiResult<T>>(this.base + path, { params, context: new HttpContext().set(LOCAL_REQUEST_FEEDBACK, true) }).pipe(map(result => {
      if (!result.Ok || !result.Data) throw new Error(result.Message || 'Unable to load report data.');
      return result.Data;
    }));
  }
}
